/**
 * Returns true if `a` is an Array.
 *
 * @example
 * ```ts
 * isArray([1, 2, 3]); // true
 * isArray(2); // false
 * ```
 */
const isArray = (input) => Array.isArray(input);
export default isArray;
//# sourceMappingURL=isArray.js.map